import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    addToChainBefore,
    ApiHandler,
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { AddProductApiParameter, addProductWithResult } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    chain,
    LoadCart,
    SendDataToApi,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import setShowRequisitionCartDisclaimer from "@tKgpco/Handlers/RequistionCart/Handlers/showRequisitionCartDisclaimer";
import { addProductWithResultReelId } from "@tKgpco/Services/ReelIdCartService";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

export interface AddProductApiParameterCustom extends AddProductApiParameter {
    properties: any;
}

type Parameter = {
    onError?: (error: string) => void;
} & AddProductApiParameterCustom &
    HasOnSuccess<CartLineModel>;

type Props = {
    apiParameter: AddProductApiParameterCustom;
    apiResult: CartLineModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterCustom: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;

    if (state.KGPState.RequistionCartStore.isRequistionCartPresent) {
        props.dispatch(setShowRequisitionCartDisclaimer({ showDisclaimerForRequistionCart: true }));
        return false;
    }
};

export const SendDataToApiCustom: HandlerType = async props => {
    const result = props.parameter?.properties?.reelId
        ? await addProductWithResultReelId(props.apiParameter)
        : await addProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result as unknown as CartLineModel;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const LoadCartCustom: HandlerType = async props => {
    const awaitableLoadCurrentCart = makeHandlerChainAwaitable(loadCurrentCart);
    await awaitableLoadCurrentCart({ getPromotions: true, getCartLines: true })(props.dispatch, props.getState);
};

addToChainBefore(chain, PopulateApiParameter, PopulateApiParameterCustom);
replaceInChain(chain, SendDataToApi, SendDataToApiCustom);
replaceInChain(chain, LoadCart, LoadCartCustom);
